import addDays from 'date-fns/addDays';
import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import addSeconds from 'date-fns/addSeconds';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import parse from 'date-fns/parse';
import setHours from 'date-fns/setHours';
import setMinutes from 'date-fns/setMinutes';
import startOfMinute from 'date-fns/startOfMinute';

export const convertScenarioMessageTimestamp = (
  timestamp: number | string | Date = 0
) => {
  if (!timestamp) {
    return Date.now();
  }
  if (typeof timestamp === 'number') {
    return timestamp;
  }

  if (typeof timestamp === 'string') {
    if (!isNaN(parse(timestamp, 'yyyy-MM-dd HH:mm:ss', new Date()).valueOf())) {
      return parse(timestamp, 'yyyy-MM-dd HH:mm:ss', new Date()).valueOf();
    }
    let result = new Date();
    timestamp.split(' ').forEach((token) => {
      if (!isNaN(parse(token, 'h:mmaa', new Date()).valueOf())) {
        const parsedDate = parse(token, 'h:mmaa', new Date());
        result = startOfMinute(
          setMinutes(
            setHours(result, getHours(parsedDate)),
            getMinutes(parsedDate)
          )
        );
      } else if (!isNaN(parse(token, 'haa', new Date()).valueOf())) {
        const parsedDate = parse(token, 'haa', new Date());
        result = startOfMinute(
          setMinutes(setHours(result, getHours(parsedDate)), 0)
        );
      } else if (token.endsWith('d')) {
        result = addDays(result, parseInt(token.slice(0, -1), 10));
      } else if (token.endsWith('h')) {
        const hours = parseInt(token.slice(0, -1), 10);
        result = addHours(result, hours);
      } else if (token.endsWith('m')) {
        const minutes = parseInt(token.slice(0, -1), 10);
        result = addMinutes(result, minutes);
      } else if (token.endsWith('s')) {
        const seconds = parseInt(token.slice(0, -1), 10);
        result = addSeconds(result, seconds);
      }
    });
    return result.valueOf();
  }

  return (timestamp as Date).valueOf();
};
